// extracted by mini-css-extract-plugin
export default {"layout":"d9a767f928 _8df0ff8951 _0d0aefc134","h_slide":"_393af76fc7","category":"_1599d6efdd ca0143ed57 _235e5744d8"};